// Module
var code = "<div class=\"alert alert-info\" role=\"alert\"> <span class=\"glyphicon glyphicon-info-sign\"></span> <span translate=\"REGISTRES.TABULATOR_INFO\"></span> </div> <massia-tabulator grid-api=\"$ctrl.gridApi\" grid-config=\"$ctrl.gridConfig\" dataset=\"$ctrl.dataset\"> </massia-tabulator> ";
// Exports
module.exports = code;